// extracted by mini-css-extract-plugin
module.exports = {"textModalHead":"text-modal-head_component_textModalHead__8q8i9"};